import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<polyline stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" points="15 18 9 12 15 6" />
	</svg>
);
export default SvgChevronLeft;
